<template>
  <div
  class="pb-7 pr-0 pr-md-3"
  >
    <div
      class="pb-3 d-none d-md-block text-h6 font-wieght-bold">
      {{ dataAll.getStatic('product_pag_selectors_title','Filter') }} 
    </div>

    <v-row v-if="!mdAndUp">
       <v-col class="py-1" > 
                <v-select
                
                density="compact"
                variant="underlined"
                :label="dataAll.getStatic('product_pag_sort','sort')"
                :items="sortColumnData"
                item-title="title"
                item-value="value"
                :menu-props="selectOptionsWhiteBackground"
                v-model="selectedFilters['sort']"
                ></v-select>
       </v-col>
    </v-row>
    <v-row  v-if="!mdAndUp">
       <v-col class="py-1">
               <v-select
                density="compact"
                variant="underlined"
                :label="dataAll.getStatic('product_pag_sort_direction','direction')"
               
                :items="[
                    { title: dataAll.getStatic('product_pag_sort_direction_asc','Ascending'), value: 'asc' },
                    { title: dataAll.getStatic('product_pag_sort_direction_desc','Descending'), value: 'desc' }
                ]"
                item-title="title"
                item-value="value"
                :menu-props="selectOptionsWhiteBackground"
                v-model="selectedFilters['direction']"
                ></v-select>
       </v-col>
    </v-row>
    <v-row v-if="!mdAndUp">
       <v-col class="py-1">
                <v-select
                    density="compact"
                    variant="underlined"
                    :label="dataAll.getStatic('product_pag_items_per_page','sort')"
                    :items="$PAG.itemPerPageOptions()"
                    :menu-props="selectOptionsWhiteBackground"
                    v-model="selectedFilters['page_size']"
                >
                </v-select>
       </v-col>
    </v-row>
    <v-row v-for="(selectorItem, index) in selectors" :key="index"
    >
      <v-col class="py-1">
        <!-- Loop all the entries in the JSON -->  
      <SelectorDropDown       
          v-if="selectorItem.SelectorType == 'dropdown'"  

          v-model="selectedFilters[$PAG.getFilterKey(selectorItem.AttribuutSelectorName, pagData)]"
          :pagData="pagData" 
          :selectorItem="selectorItem" 
        />        
      <SelectorMultiCheckbox  
          v-if="selectorItem.SelectorType == 'multiCheckBox'" 
          v-model="selectedFilters[$PAG.getFilterKey(selectorItem.AttribuutSelectorName, pagData)]"
          :pagData="pagData" 
          :selectorItem="selectorItem" 
        />             
        <SelectorRange
          v-if="selectorItem.SelectorType == 'range'" 
          v-model="selectedFilters[$PAG.getFilterKey(selectorItem.AttribuutSelectorName, pagData)]"
          :pagData="pagData" 
          :selectorItem="selectorItem" 
        />        
      </v-col>
      
    </v-row>
    <v-row
    >
      <v-col 
        class="pt-1">
        <SelectorSearch
        :selectedFilters="selectedFilters" 
        :pagData="props.pagData" 
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { onMounted, onUpdated, onBeforeUnmount, onBeforeMount } from "vue";
import SelectorDropDown from "@/components/Products/PAG/SelectorControls/SelectorDropDown.vue";
import SelectorMultiCheckbox from "@/components/Products/PAG/SelectorControls/SelectorMultiCheckbox.vue";
import SelectorRange from "@/components/Products/PAG/SelectorControls/SelectorRange.vue";
import SelectorSearch from "@/components/Products/PAG/SelectorControls/SelectorSearch.vue";
import { mapSortedHeaders } from '~/utils/PAGhelper'
const { mobile, xs, mdAndUp  } = useDisplay();
const dataAll = useDataAll();
const { $PAG } = useNuxtApp()
const props = defineProps({
  selectors: {
    type: Object,
    default: "",
  },
  pageItem: {
    type: Object,
    default: "",
  },  
  pagData: {
    type: Object,
    default: "",
  }, 
});

const selectedFilters = ref({}); // selected values in filter pulldowns

// retrieve filters form url and selectedFilters will preselect controls
selectedFilters.value = $PAG.selectFilterValueByUrl();
// Watch for changes in selectedFilters
watch(
  selectedFilters,
  () => $PAG.updateFilter(selectedFilters.value,null),
  { deep: true }
);

const sortColumnData = computed(() => mapSortedHeaders(props.pageItem?.Selector))

</script>
